import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { getImageUrl, convertEpochTime } from "../../common/utils";
// import { FrontAwesomeIcon } from "@fortawesome/react-frontawesome";
// import { faFilePdf, faFileWord, faDownload } from "@fortawesome/free-solid-svg-icons";
import EmbedPoll from "../EmbedPoll/EmbedPoll";
import MediaPlayerWrapper from "../../components/ThemeTwo/MediaPlayerWrapper";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const allowedTypes = ['inlinevideo', 'SURVEY', 'QUIZ', 'ExtQuote', 'Article', 'Poll', 'document', 'inlineimage'];

const EmbedGroupSlider = ({ embeds, slideData, baseDomain, constants, clientHostId }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
  }, [slideData]);

  function getEmbedInfo(msid) {
    return embeds ? embeds.find(embed => embed.msid === msid) : null;
  }

  const Slide = ({ slide }) => {
    let content;
    switch (slide.type) {
      case 'inlinevideo':
        const videoInfo = getEmbedInfo(slide.id);
        const slikeID = slide.playerType === 'slike'
          ? (isNaN(slide.id) ? slide.id : slide.playerId)
          : slide.playerType === 'youtube'
            ? `yt${slide.playerId}`
            : slide.playerType === ''
              ? (videoInfo?.media?.rmname === 'youtube'
                ? `yt${videoInfo?.media?.id}`
                : videoInfo?.media?.id)
              : slide.id;
        
        content = (
          <div className="CommonEmbedGroupItemsInnerWrapper">
            <div className="CommonEmbedGroupMediaPlayerWrapper responsive-player">
                  <MediaPlayerWrapper
                    containerId={`playerContainer_${slikeID}`}
                    apiKey="test403web5a8sg6o9ug"
                    slikeId={slikeID}
                    Pl_Type="Video"
                    autoPlay={false}
                    skipAd={true}
                    mute={false}
                    playInBackground={true}
                    pipMode={false}
                  />
            </div>
            <div className="CommonEmbedGroupTitle">{slide?.hl}</div>
          </div>
        );
        break;

      case 'SURVEY':
      case 'QUIZ':
        const surveyInfo = getEmbedInfo(slide.msid);
        content = (
          <div>
            <a target="_self" href={`/${surveyInfo?.seopath}/slideshow/${surveyInfo?.parentid}.html`} className="CommonEmbedGroupItemsWrapper">
              <div className="CommonEmbedGroupItemsInnerWrapper">
                <div className="CommonEmbedGroupHeading">{surveyInfo?.title}</div>
                <div className="CommonEmbedSurveyQuizTimeWrap">{convertEpochTime(surveyInfo?.updatedate, '', "DD MMM YYYY")} - <div className="CommonEmbedSurveyQuizAuthorName">{surveyInfo && surveyInfo?.authors && surveyInfo?.authors[0]?.name || ''}</div></div>
                <div className="CommonEmbedSurveyQuizSynopsis" dangerouslySetInnerHTML={{ __html: surveyInfo?.synopsis }}></div>
                <div className="CommonEmbedSurveyButton"><a target="_self" href={`${surveyInfo?.seopath}/${surveyInfo?.cmstype === "SURVEY" ? 'surveyshow' : 'quizshow'}/${surveyInfo?.msid}.html`}><button>{`${surveyInfo?.cmstype === "SURVEY" ? 'START SURVEY' : 'START QUIZ'}`}</button></a></div>
              </div>
            </a>
          </div>
        );
        break;

      case 'slideshow':
        const slideshowInfo = getEmbedInfo(slide.msid);
        content = (
          <div>
            <a target="_self" href={`/${slideshowInfo?.seopath}/slideshow/${slideshowInfo?.msid}.html`} className="CommonEmbedGroupItemsWrapper">
              <div className="CommonEmbedGroupItemsInnerWrapper">
                <div className="CommonGroupEmbedSlideShowWrap">
                  <img
                    src={`${getImageUrl(
                      slideshowInfo.msid,
                      slideshowInfo.thumbsize,
                      616,
                      undefined,
                      baseDomain,
                      false,
                      constants
                    )}&pageno=1`}
                  />
                  <div className="CommonGroupEmbedSlideShowTitle">{slideshowInfo?.title}</div>
                </div>
              </div>
            </a>
          </div>
        )


      case 'ExtQuote':
        content = (
          <div className="CommonEmbedGroupItemsInnerWrapper">
            <div className="CommonEmbedQuotesIconWrap">
              <span className='CommonEmbedQuotesIcon'><svg width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.698242 25.4639V19.2012C0.698242 17.0964 1.04329 14.9053 1.7334 12.6279C2.45801 10.3161 3.49316 8.10775 4.83887 6.00293C6.18457 3.86361 7.80632 2.01758 9.7041 0.464844L15.1387 4.24316C13.5514 6.52051 12.3265 8.86686 11.4639 11.2822C10.6012 13.6631 10.1699 16.251 10.1699 19.0459V25.4639H0.698242ZM17.002 25.4639V19.2012C17.002 17.0964 17.347 14.9053 18.0371 12.6279C18.7617 10.3161 19.7969 8.10775 21.1426 6.00293C22.4883 3.86361 24.11 2.01758 26.0078 0.464844L31.4424 4.24316C29.8551 6.52051 28.6302 8.86686 27.7676 11.2822C26.9049 13.6631 26.4736 16.251 26.4736 19.0459V25.4639H17.002Z" fill="black" />
              </svg>
              </span>
            </div>
            <div className="CommonEmbedGroupSummary">{slide?.value}</div>
            <div className="CommonEmbedQuoteAuthor">By : {slide?.au}</div>
          </div>
        );
        break;

      case 'Article':
        const articleInfo = getEmbedInfo(slide.msid);
        content = (
          <div className="CommonEmbedGroupItemsInnerWrapper">
            <a href={`/${articleInfo?.seopath}/articleshow/${articleInfo?.msid}.html`}>
              <div className="CommonEmbedGroupHeading">{articleInfo?.cmstype}</div>
              <div className="CommonGroupMediaTitle">
                <div className="CommonEmbedGroupTitle">{articleInfo?.title}</div>
                <div className="CommonEmbedSurveyQuizTimeWrap">{convertEpochTime(slide?.updatedate, '', "DD MMM YYYY")} - <div className="CommonEmbedSurveyQuizAuthorName">{articleInfo && articleInfo?.authors && articleInfo?.authors[0]?.name || ''}</div></div>
              </div>
              <div className="CommonEmbedGroupArticle" key={articleInfo?.msid}>
                <div className="CommonEmbedGroupArticleImageWrap">
                  <div className="CommonEmbedGroupArticleSynopsis"><p>  <img style={{ width: "90" }} src={`${getImageUrl(articleInfo?.msid, articleInfo?.thumbsize, 90, undefined, baseDomain, false, constants)}`} alt={articleInfo?.title} />  {articleInfo?.synopsis}</p></div>
                </div>

              </div>
            </a>
          </div>
        );
        break;

        case 'Poll':
          const pollInfo = getEmbedInfo(slide.msid);
           content = (
            <div className="CommonEmbedGroupItemsInnerWrapper">
            <div className="CommonEmbedGroupHeading">{pollInfo?.title}</div>
            <EmbedPoll className="CommonEmbedGroupPoll" pollObject={pollInfo}
              baseDomain={baseDomain}
              constants={constants} />
          </div>
          
           );
          break;

          case 'document':
            const documentInfo = getEmbedInfo(slide.msid);
            console.log('6666666', documentInfo)
             content = (
              <a
                  target="_self"
                  href={`${getImageUrl(
                    documentInfo.msid,
                    documentInfo.thumbsize,
                    616,
                    undefined,
                    baseDomain,
                    false,
                    constants
                  )}`}
                >
                  <div className="CommonEmbedGroupItemsInnerWrapper">
                    {/* <div className="CommonEmbedGroupHeading">PDF</div> */}
                    <div className="CommonEmbedGroupHeading">{documentInfo?.title}</div>
                    <div className="CommonEmbedGroupPdfImageWrap">
                      <img
                      style={{ width: "236px" }}
                        src={`${getImageUrl(
                          documentInfo.msid,
                          documentInfo.thumbsize,
                          616,
                          undefined,
                          baseDomain,
                          false,
                          constants
                        )}&pageno=1`}
                      />
                     <div className="CommonEmbedGroupPdfIconWrap">
                     {/* <FrontAwesomeIcon icon={faFilePdf} size="2x" color="red" /> */}
                     <div className='bg-PDF_icon_embed' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
                     <div className='bg-Download_icon_embed' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
                     {/* <FrontAwesomeIcon icon={faDownload}  size="2x" color="red" /> */}
                     </div>
                    </div>
                  </div>
                </a>
            
             );
            break;

      case 'inlineimage':
        // const imageInfo = getEmbedInfo(slide.imageId);
        content = (
          <div className="CommonEmbedGroupItemsInnerWrapper">
            <div className="CommonGroupEmbedSlideShowWrap">
              <img
                src={`${getImageUrl(
                  // imageInfo.msid,
                  slide.imageId,
                  // imageInfo.thumbsize,
                  slide.imagesize,
                  616,
                  undefined,
                  baseDomain,
                  false,
                  constants
                )}&pageno=1`}
                alt={slide.altTitle}
              />
              <div className="CommonGroupEmbedSlideShowTitle">{slide?.title}</div>
            </div>
          </div>
        );
        break;
      case 'wikipedia' : 
      content = (
      <iframe
            src={slide.url}
            width="100%"
            height="400"
            style={{ border: 'none' }}
            allowFullScreen>
          </iframe>
      )
      default:
        content = <div><h3>Unsupported type: {slide.type}</h3></div>;
    }

    return <div>{content}</div>;
  };










  // Slider settings
  const settings = {
    dots: true,
    nav: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2, // Ensure only 2 slides are shown
    slidesToScroll: 1,
    className: 'CommonEmbedGroupSlider',
    initialSlide: 0,
    swipeToSlide: true,
    variableWidth: false, // Ensure each slide takes up an equal share
    centerMode: false, // Ensure centerMode is disabled
    arrows: false,
    gutter: 20,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1, // Shows only 2 slides on smaller screens
          arrows: false,
          dots: true,
          autoPlay: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1, // For very small screens, show only 1 slide
          arrows: false,
          dots: true,
          autoPlay: true,
          variableWidth: false, // Ensure each slide takes up an equal share
        }
      }
    ]
  };




  const filteredSlides = slideData.filter(slide => allowedTypes.includes(slide.type));

  return (
    <div id="contentContainer">
      <Slider {...settings}>
      {filteredSlides.map(slide => (
          <Slide key={slide.id} slide={slide} />
        ))}
      </Slider>
    </div>
  );
  
};

export default EmbedGroupSlider;
